Jelly.Actions.Lock = function(Parameters) { 
	
	// Get action reference
	var Action_Reference = Jelly.References.Get_Reference_For_Element(
		$('#' + Parameters.Namespace).get(0)
	);

	// Validate action reference
	if (!Jelly.Actions.Is_Action_Reference(Action_Reference))
		return;

	// Lock action
	Action_Reference.Uploads_In_Progress[Parameters.Input_Alias] = true;
};